<template>
  <div v-if="form">
    <div class="d-flex justify-content-end mb-3">
      <b-button
        v-if="!hasAnyRowEditing"
        variant="primary"
        @click="addRowDetail"
      >
        <i class="fa fa-plus"></i>
        Add Detail Shipment
      </b-button>
      <template v-else>
        <b-button variant="primary" @click="$emit('submit')">
          <i class="fa fa-floppy-o"></i>
          Save Update
        </b-button>
        <b-button
          class="ml-2"
          variant="outline-secondary"
          @click="cancelUpdate"
        >
          Cancel Update
        </b-button>
      </template>
    </div>

    <div class="table-container">
      <table class="table table-bordered table-fixed-header">
        <thead class="thead-light sticky-header">
          <tr>
            <th
              v-if="!isDetail"
              style="width: 20px"
              rowspan="2"
              class="text-truncate text-center align-middle column-1"
            >
              <b-form-checkbox />
            </th>
            <th
              v-if="!isDetail"
              rowspan="2"
              class="column-2 text-center align-middle"
            >
              <i
                class="fa fa-trash-alt text-danger cursor-pointer"
                @click="deleteAll"
              ></i>
            </th>
            <th
              v-if="isDetail"
              rowspan="2"
              class="text-center align-middle column-1"
            >
              <i
                class="fa"
                :class="
                  allRowsEditing
                    ? 'fa-trash-alt text-danger'
                    : 'fa-edit text-primary'
                "
                :title="allRowsEditing ? 'Delete All Rows' : 'Edit Semua Baris'"
                @click="allRowsEditing ? deleteAll() : toggleAllRowsEdit()"
              />
            </th>
            <th
              class="text-truncate align-middle"
              :class="isDetail ? 'column-number-detail' : 'column-number-edit'"
              rowspan="2"
            >
              <span class="text-capitalize">Number Detail Plan</span>
              <span style="color: red">*</span>
            </th>
            <th class="text-truncate text-center" :colspan="3">
              <span class="text-capitalize">Fleet</span>
            </th>
            <th class="text-truncate text-center" colspan="3">
              <span class="text-capitalize">Cargo Type</span>
            </th>
            <th class="text-truncate text-center" rowspan="2">
              <span class="text-capitalize">Draught Type</span>
            </th>
            <th class="text-truncate text-center" colspan="2">
              <span class="text-capitalize">Location</span>
            </th>
            <th class="text-truncate text-center" rowspan="2">
              <span class="text-capitalize">Shipment Month</span>
            </th>
            <th class="text-truncate text-center" colspan="2">
              <span class="text-capitalize">Plan Date</span>
            </th>
            <th class="text-truncate text-center" rowspan="2">
              <span class="text-capitalize">Plan Quantity</span>
              <span style="color: red">*</span>
            </th>
            <th class="text-truncate align-middle" rowspan="2">
              <span class="text-capitalize">Description</span>
            </th>
            <th class="text-truncate align-middle" rowspan="2">
              <span class="text-capitalize">Remarks</span>
            </th>
          </tr>
          <tr>
            <th class="text-truncate">
              <span class="text-capitalize">Ownership</span>
              <span style="color: red">*</span>
            </th>
            <!-- <th class="text-left text-truncate">
            <span class="text-capitalize">Type</span>
            <span style="color: red">*</span>
          </th> -->
            <th class="text-truncate">
              <span class="text-capitalize">First Fleet</span>
              <span style="color: red">*</span>
            </th>
            <th class="text-truncate">
              <span class="text-capitalize">Second Fleet</span>
            </th>
            <th class="text-truncate">
              <span class="text-capitalize">Type</span>
              <span style="color: red">*</span>
            </th>
            <th class="">
              <span class="text-capitalize text-truncate">Acc. Date</span>
            </th>
            <th class="text-truncate">
              <span class="text-capitalize">Terms</span>
              <span style="color: red">*</span>
            </th>
            <th class="text-truncate">
              <span class="text-capitalize">Port Of Loading</span>
            </th>
            <th class="text-truncate">
              <span class="text-capitalize">Port Of Dhischarge</span>
            </th>
            <th class="text-truncate">
              <span class="text-capitalize">ETA POL</span>
            </th>
            <th class="text-truncate">
              <span class="text-capitalize">ETA POD</span>
            </th>
          </tr>
        </thead>
        <tbody v-if="form.detail_plan?.length" class="scrollable-body">
          <tr v-for="(state, index) in form.detail_plan" :key="index">
            <td
              v-if="isDetail"
              class="text-center align-center column-1 bg-white"
            >
              <template v-if="state?.can_delete">
                <i
                  class="fa"
                  :class="
                    isRowEditing(index)
                      ? 'fa-trash-alt text-danger'
                      : 'fa-edit text-primary'
                  "
                  :title="isRowEditing(index) ? 'Delete Row' : 'Edit Row'"
                  @click="
                    isRowEditing(index) ? deleteRow(index) : startRowEdit(index)
                  "
                />
              </template>
              <template v-else>
                <i
                  v-if="isRowEditing(index) ? false : true"
                  class="fa fa-edit text-primary"
                  :title="'Edit Row'"
                  @click="startRowEdit(index)"
                />
              </template>
            </td>
            <td
              v-if="!isDetail"
              class="text-center align-center column-1 bg-white"
            >
              <b-form-checkbox type="checkbox" />
            </td>
            <td
              v-if="!isDetail"
              class="text-center align-center column-2 bg-white"
            >
              <i
                class="fa fa-trash-alt text-danger cursor-pointer"
                @click="deleteRow(index)"
              />
            </td>
            <td
              class="text-truncate bg-white"
              :class="isDetail ? 'column-number-detail' : 'column-number-edit'"
              style="min-width: 300px"
            >
              <template v-if="isDetail">
                <span class="form-control-plaintext d-inline-block">
                  {{ generateShipmentPlanNumber(form, state, index) }}
                </span>
              </template>
              <template v-else>
                {{ generateShipmentPlanNumber(form, state, index) }}
              </template>
            </td>
            <td class="text-left">
              <template v-if="!isDetail">
                <b-form-select
                  plain
                  v-model="state.fleet_ownership"
                  class="form-control"
                  name="fleet_ownership"
                  style="width: 200px"
                >
                  <!-- @change="onChangeOwnership(state.fleet_ownership)" -->
                  <option value="">Select ownership...</option>
                  <option value="own-ship">OWN SHIP</option>
                  <option value="chartered">CHARTERED</option>
                </b-form-select>
              </template>
              <template v-else>
                <template v-if="isRowEditing(index)">
                  <b-form-select
                    plain
                    v-model="state.fleet_ownership"
                    class="form-control d-inline-block"
                    style="width: 200px"
                  >
                    <option value="">Select ownership...</option>
                    <option value="own-ship">OWN SHIP</option>
                    <option value="chartered">CHARTERED</option>
                  </b-form-select>
                </template>
                <template v-else>
                  <span class="form-control-plaintext">
                    {{
                      state.fleet_ownership === 'own-ship'
                        ? 'OWN SHIP'
                        : state.fleet_ownership === 'chartered'
                        ? 'CHARTERED'
                        : state.fleet_ownership || '-'
                    }}
                  </span>
                </template>
              </template>
            </td>
            <!-- <td class="text-left">
            <b-form-select
              
              style="width: 200px"
              plain
              v-model="state.fleet_type_id"
              :options="optionsFleetTypes"
              class="form-control"
              
              name="fleet_type_id"
              @change="onChangeFleetType(true, state.fleet_type_id, index)"
            >
              <template v-slot:first>
                <b-form-select-option :value="null"
                  >Select fleet type...</b-form-select-option
                >
              </template>
            </b-form-select>
          </td> -->
            <td class="text-left">
              <template v-if="!isDetail">
                <SearchableSelect
                  v-model="state.fleet_id"
                  :options="filteredFleetOptions"
                  value-field="value"
                  text-field="text"
                  :disabled="!hasSelectedFleetTypes"
                  placeholder="Select fleet..."
                  style="width: 200px"
                />
              </template>
              <template v-else>
                <template v-if="isRowEditing(index)">
                  <SearchableSelect
                    v-model="state.fleet_id"
                    :options="filteredFleetOptions"
                    value-field="value"
                    text-field="text"
                    placeholder="Select fleet..."
                    style="width: 200px"
                  />
                </template>
                <template v-else>
                  <span class="form-control-plaintext">
                    {{
                      fleetOptions.find((opt) => opt.value === state.fleet_id)
                        ?.text ||
                      state.fleet_id ||
                      '-'
                    }}
                  </span>
                </template>
              </template>
            </td>
            <td class="text-left">
              <template v-if="!isDetail">
                <SearchableSelect
                  v-model="state.second_fleet_id"
                  :options="filteredFleetOptions"
                  value-field="value"
                  text-field="text"
                  :disabled="!hasSelectedFleetTypes"
                  placeholder="Select fleet..."
                  style="width: 200px"
                />
              </template>
              <template v-else>
                <template v-if="isRowEditing(index)">
                  <SearchableSelect
                    v-model="state.second_fleet_id"
                    :options="filteredFleetOptions"
                    value-field="value"
                    text-field="text"
                    placeholder="Select fleet..."
                    style="width: 200px"
                  />
                </template>
                <template v-else>
                  <span class="form-control-plaintext">
                    {{
                      fleetOptions.find(
                        (opt) => opt.value === state.second_fleet_id
                      )?.text ||
                      state.second_fleet_id ||
                      '-'
                    }}
                  </span>
                </template>
              </template>
            </td>
            <td class="text-left">
              <template v-if="!isDetail">
                <b-form-select
                  name="cargo_type_id"
                  v-model="state.cargo_type_id"
                  :options="optionsCargoType"
                  value-field="value"
                  text-field="text"
                  style="width: 200px"
                  plain
                >
                  <template v-slot:first>
                    <b-form-select-option :value="null">
                      Select Cargo Type...
                    </b-form-select-option>
                  </template>
                </b-form-select>
              </template>
              <template v-else>
                <template v-if="isRowEditing(index)">
                  <b-form-select
                    name="cargo_type_id"
                    v-model="state.cargo_type_id"
                    :options="optionsCargoType"
                    value-field="value"
                    text-field="text"
                    style="width: 200px"
                    plain
                  >
                    <template v-slot:first>
                      <b-form-select-option :value="null">
                        Select Cargo Type...
                      </b-form-select-option>
                    </template>
                  </b-form-select>
                </template>
                <template v-else>
                  <span class="form-control-plaintext">
                    {{
                      optionsCargoType.find(
                        (opt) => opt.value === state.cargo_type_id
                      )?.text ||
                      state.cargo_type_id ||
                      '-'
                    }}
                  </span>
                </template>
              </template>
            </td>
            <td class="text-left">
              <template v-if="!isDetail">
                <date-picker
                  v-model="state.acceptance_date"
                  class="custom-date-picker"
                  value-type="YYYY-MM-DD HH:mm"
                  type="datetime"
                  placeholder="Select date"
                  format="DD-MM-YYYY HH:mm"
                  style="width: 200px"
                ></date-picker>
              </template>
              <template v-else>
                <template v-if="isRowEditing(index)">
                  <date-picker
                    v-model="state.acceptance_date"
                    class="custom-date-picker"
                    value-type="YYYY-MM-DD HH:mm"
                    type="datetime"
                    placeholder="Select date"
                    format="DD-MM-YYYY HH:mm"
                    style="width: 200px"
                  />
                </template>
                <template v-else>
                  <span class="form-control-plaintext">
                    {{
                      state.acceptance_date
                        ? moment(state.acceptance_date).format(
                            'DD MMM YYYY HH:mm'
                          )
                        : '-'
                    }}
                  </span>
                </template>
              </template>
            </td>
            <td class="text-left">
              <template v-if="!isDetail">
                <div class="d-flex align-items-center">
                  <b-form-select
                    style="width: 80px"
                    class="mr-2"
                    plain
                    size="sm"
                    :options="optionsProjectTerms"
                    v-model="state.terms_id"
                  >
                    <b-form-select-option :value="null">
                      Select Term
                    </b-form-select-option>
                  </b-form-select>
                  <b-form-input
                    style="width: 240px"
                    rows="2"
                    placeholder="Text Type"
                    v-model="state.terms_remarks"
                  />
                </div>
              </template>
              <template v-else>
                <template v-if="isRowEditing(index)">
                  <div class="d-inline-flex align-items-center">
                    <b-form-select
                      style="width: 80px"
                      class="mr-2"
                      plain
                      size="sm"
                      :options="optionsProjectTerms"
                      v-model="state.terms_id"
                    >
                      <b-form-select-option :value="null">
                        Select Term
                      </b-form-select-option>
                    </b-form-select>
                    <b-form-input
                      style="width: 240px"
                      rows="2"
                      placeholder="Text Type"
                      v-model="state.terms_remarks"
                    />
                  </div>
                </template>
                <template v-else>
                  <span class="form-control-plaintext">
                    {{
                      optionsProjectTerms.find(
                        (opt) => opt.value === state.terms_id
                      )?.text ||
                      state.terms_id ||
                      '-'
                    }}
                    {{ state.terms_remarks ? ' - ' + state.terms_remarks : '' }}
                  </span>
                </template>
              </template>
            </td>
            <td class="text-left">
              <template v-if="!isDetail">
                <b-form-select
                  style="width: 200px"
                  plain
                  size="sm"
                  v-model="state.draught_type"
                >
                  <b-form-select-option value="draught_survey_loading">
                    Draught Survey Loading
                  </b-form-select-option>
                  <b-form-select-option value="draught_survey_discharge">
                    Draught Survey Discharge
                  </b-form-select-option>
                </b-form-select>
              </template>
              <template v-else>
                <template v-if="isRowEditing(index)">
                  <b-form-select
                    style="width: 200px"
                    plain
                    size="sm"
                    v-model="state.draught_type"
                  >
                    <b-form-select-option value="draught_survey_loading">
                      Draught Survey Loading
                    </b-form-select-option>
                    <b-form-select-option value="draught_survey_discharge">
                      Draught Survey Discharge
                    </b-form-select-option>
                  </b-form-select>
                </template>
                <template v-else>
                  <span class="form-control-plaintext">
                    {{
                      state.draught_type === 'draught_survey_loading'
                        ? 'Draught Survey Loading'
                        : state.draught_type === 'draught_survey_discharge'
                        ? 'Draught Survey Discharge'
                        : state.draught_type || '-'
                    }}
                  </span>
                </template>
              </template>
            </td>
            <td class="text-left align-top">
              <div
                v-for="(statePol, i) in state.pol"
                :key="i"
                class="d-flex align-items-start"
                style="width: 240px"
                :class="{ 'mb-2': state.pol?.length > 1 }"
              >
                <div class="w-100 mr-2">
                  <template v-if="!isDetail || isRowEditing(index)">
                    <b-form-select
                      class="bg-white w-100"
                      v-model="statePol.value"
                      :options="positionListTextPOL"
                      value-field="value"
                      text-field="text"
                      plain
                    >
                      <template v-slot:first>
                        <b-form-select-option :value="null">
                          Select POL...
                        </b-form-select-option>
                      </template>
                    </b-form-select>
                    <b-form-input
                      v-if="statePol.value == 'other'"
                      class="mt-1"
                      type="text"
                      v-model="statePol.valueOther"
                      placeholder="Other pol..."
                    />
                  </template>
                  <template v-else>
                    <span class="form-control-plaintext">
                      {{
                        positionListTextPOL.find(
                          (opt) => opt.value === statePol.value
                        )?.text ||
                        (statePol.value === 'other'
                          ? statePol.valueOther
                          : statePol.value) ||
                        '-'
                      }}
                    </span>
                  </template>
                </div>
                <i
                  v-if="i == 0 && (!isDetail || isRowEditing(index))"
                  class="fa fa-plus rounded-circle border text-success border-success p-2 cursor-pointer"
                  @click="
                    state.pol.push({
                      value: form.ports[state.pol.length]?.pol || '',
                      valueOther:
                        form.ports[state.pol.length]?.valueOther || '',
                    })
                  "
                ></i>
                <i
                  v-else-if="!isDetail || isRowEditing(index)"
                  class="fa fa-trash-alt rounded-circle border text-danger border-danger p-2 cursor-pointer"
                  @click="state.pol.splice(i, 1)"
                ></i>
              </div>
            </td>
            <td class="text-left align-top">
              <div
                v-for="(statePol, i) in state.pod"
                :key="i"
                class="d-flex align-items-start"
                style="width: 240px"
                :class="{ 'mb-2': state.pod?.length > 1 }"
              >
                <div class="w-100 mr-2">
                  <template v-if="!isDetail || isRowEditing(index)">
                    <b-form-select
                      class="bg-white w-100"
                      v-model="statePol.value"
                      :options="positionListTextPOD"
                      value-field="value"
                      text-field="text"
                      plain
                    >
                      <template v-slot:first>
                        <b-form-select-option :value="null">
                          Select POD...
                        </b-form-select-option>
                      </template>
                    </b-form-select>
                    <b-form-input
                      v-if="statePol.value == 'other'"
                      class="mt-1"
                      type="text"
                      v-model="statePol.valueOther"
                      placeholder="Other pod..."
                    />
                  </template>
                  <template v-else>
                    <span class="form-control-plaintext">
                      {{
                        positionListTextPOD.find(
                          (opt) => opt.value === statePol.value
                        )?.text ||
                        (statePol.value === 'other'
                          ? statePol.valueOther
                          : statePol.value) ||
                        '-'
                      }}
                    </span>
                  </template>
                </div>
                <i
                  v-if="i == 0 && (!isDetail || isRowEditing(index))"
                  class="fa fa-plus rounded-circle border text-success border-success p-2 cursor-pointer"
                  @click="
                    state.pod.push({
                      value: form.ports[state.pod.length]?.pod || '',
                      valueOther:
                        form.ports[state.pod.length]?.valueOther || '',
                    })
                  "
                ></i>
                <i
                  v-else-if="!isDetail || isRowEditing(index)"
                  class="fa fa-trash-alt rounded-circle border text-danger border-danger p-2 cursor-pointer"
                  @click="state.pod.splice(i, 1)"
                ></i>
              </div>
            </td>
            <td class="text-left">
              <template v-if="!isDetail || isRowEditing(index)">
                <b-form-select
                  style="width: 200px"
                  plain
                  size="sm"
                  v-model="state.shipment"
                >
                  <b-form-select-option value="">
                    SELECT MONTH
                  </b-form-select-option>
                  <b-form-select-option value="JANUARY">
                    JANUARI
                  </b-form-select-option>
                  <b-form-select-option value="FEBRUARI">
                    FEBRUARI
                  </b-form-select-option>
                  <b-form-select-option value="MARET">
                    MARET
                  </b-form-select-option>
                  <b-form-select-option value="APRIL">
                    APRIL
                  </b-form-select-option>
                  <b-form-select-option value="MEI">MEI</b-form-select-option>
                  <b-form-select-option value="JUNI">JUNI</b-form-select-option>
                  <b-form-select-option value="JULI">JULI</b-form-select-option>
                  <b-form-select-option value="AGUSTUS">
                    AGUSTUS
                  </b-form-select-option>
                  <b-form-select-option value="SEPTEMBER">
                    SEPTEMBER
                  </b-form-select-option>
                  <b-form-select-option value="OKTOBER">
                    OKTOBER
                  </b-form-select-option>
                  <b-form-select-option value="NOVEMBER">
                    NOVEMBER
                  </b-form-select-option>
                  <b-form-select-option value="DESEMBER">
                    DESEMBER
                  </b-form-select-option>
                </b-form-select>
              </template>
              <template v-else>
                <span class="form-control-plaintext">
                  {{ state.shipment || '-' }}
                </span>
              </template>
            </td>

            <td class="text-left">
              <template v-if="!isDetail || isRowEditing(index)">
                <b-form-input
                  style="width: 200px"
                  type="date"
                  id="eta_pol"
                  v-model="state.eta_pol"
                  size="sm"
                ></b-form-input>
              </template>
              <template v-else>
                <span class="form-control-plaintext">
                  {{
                    state.eta_pol
                      ? moment(state.eta_pol).format('DD MMM YYYY')
                      : '-'
                  }}
                </span>
              </template>
            </td>
            <td class="text-left">
              <template v-if="!isDetail || isRowEditing(index)">
                <b-form-input
                  style="width: 200px"
                  type="date"
                  id="eta_pod"
                  v-model="state.eta_pod"
                  size="sm"
                ></b-form-input>
              </template>
              <template v-else>
                <span class="form-control-plaintext">
                  {{
                    state.eta_pod
                      ? moment(state.eta_pod).format('DD MMM YYYY')
                      : '-'
                  }}
                </span>
              </template>
            </td>
            <td class="text-left">
              <template v-if="!isDetail || isRowEditing(index)">
                <InputCurrency
                  id="plan_quantity"
                  name="plan_quantity"
                  prepend=""
                  v-model="state.plan_quantity"
                  size="sm"
                  placeholder="0"
                />
              </template>
              <template v-else>
                <span class="form-control-plaintext text-center">
                  {{
                    state.plan_quantity
                      ? currencyFormat(state.plan_quantity)
                      : '-'
                  }}
                  {{ form.unit || '' }}
                </span>
              </template>
            </td>
            <td align="center">
              <template>
                <b-button
                  variant="primary"
                  @click="openDescriptionModal(state, index)"
                  size="sm"
                >
                  Descriptions
                </b-button>
              </template>
            </td>
            <td class="text-left" align="center">
              <template>
                <b-button
                  variant="primary"
                  @click="openRemarksModal(state, index)"
                  size="sm"
                >
                  Remarks
                </b-button>
              </template>
            </td>
          </tr>
        </tbody>
      </table>
      <div
        v-if="!form.detail_plan?.length"
        class="px-3"
        style="position: sticky; left: 0"
      >
        No Data Detail Shipment Plan
      </div>
    </div>

    <!-- Description Modal -->
    <b-modal
      v-model="showDescriptionModal"
      :title="`Description`"
      ok-title="Save"
      cancel-title="Cancel"
      @ok="saveDescription"
      @cancel="cancelModal"
    >
      <b-form-group label="Description" label-for="description-textarea">
        <b-form-textarea
          id="description-textarea"
          v-model="tempDescription"
          placeholder="Type description here..."
          rows="5"
        />
      </b-form-group>
    </b-modal>

    <!-- Remarks Modal -->
    <b-modal
      v-model="showRemarksModal"
      :title="`Remarks`"
      ok-title="Save"
      cancel-title="Cancel"
      @ok="saveRemarks"
      @cancel="cancelModal"
    >
      <b-form-group label="Remarks" label-for="remarks-textarea">
        <b-form-textarea
          id="remarks-textarea"
          v-model="tempRemarks"
          placeholder="Comments if any / Komentar jika ada..."
          rows="5"
        />
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import InputCurrency from '@/src/components/global/InputCurrency.vue'
import SearchableSelect from '@/src/components/global/SearchableSelect.vue'
import moment from 'moment'

export default {
  components: {
    InputCurrency,
    SearchableSelect,
  },
  name: 'DetailShipmentPlan',
  data() {
    return {
      showDescriptionModal: false,
      showRemarksModal: false,
      currentRowIndex: null,
      currentRowData: null,
      tempDescription: '',
      tempRemarks: '',
      // reactive per-row edit states
      // { [rowIndex]: { rowEditing: boolean } }
      editStates: {},
      allRowsEditing: false,
    }
  },
  props: {
    form: {
      type: Object,
      required: true,
    },
    optionsFleetTypes: {
      type: Array,
      default: () => [],
      required: true,
    },
    fleetOptions: {
      type: Array,
      required: true,
      default: () => [],
    },
    optionsCargoType: {
      type: Array,
      required: true,
      default: () => [],
    },
    optionsProjectTerms: {
      type: Array,
      required: true,
      default: () => [],
    },
    shipmentPlanNumber: {
      type: String,
      default: '',
    },
    positionListTextPOD: {
      type: Array,
      default: () => [],
    },
    positionListTextPOL: {
      type: Array,
      default: () => [],
    },
    isDetail: {
      type: Boolean,
      default: false,
    },
    generateShipmentPlanNumber: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    hasAnyRowEditing() {
      if (!this.isDetail) return false
      if (this.allRowsEditing) return true
      return Object.values(this.editStates || {}).some((st) => st.rowEditing)
    },
    hasSelectedFleetTypes() {
      // Expect parent to use array of selected objects or values. Normalize to values array.
      const ids = (this.form?.fleet_type_ids || []).map((v) =>
        typeof v === 'object' && v !== null ? v.value : v
      )
      return ids.length > 0
    },
    selectedFleetTypeIds() {
      return (this.form?.fleet_type_ids || []).map((v) =>
        typeof v === 'object' && v !== null ? v.value : v
      )
    },
    filteredFleetOptions() {
      // If no fleet types selected, return empty array to force selection disabled UX
      if (!this.selectedFleetTypeIds.length) return []
      // Filter fleetOptions by each option's fleet_type_id / vehicleType mapping if present
      return this.fleetOptions.filter((opt) => {
        const typeId =
          opt.fleet_type_id ||
          opt.vehicle_type_id ||
          opt?.vehicleType?.vehicle_type_id
        return this.selectedFleetTypeIds.includes(typeId)
      })
    },
  },
  methods: {
    // ----- Inline edit helpers (row-level) -----
    ensureEditStateRow(index) {
      if (!this.editStates[index]) {
        this.$set(this.editStates, index, {})
      }
    },
    startRowEdit(index) {
      this.ensureEditStateRow(index)
      this.$set(this.editStates[index], 'rowEditing', true)
    },
    stopRowEdit(index) {
      if (this.editStates[index])
        this.$set(this.editStates[index], 'rowEditing', false)
    },
    isRowEditing(index) {
      return !!(this.editStates[index] && this.editStates[index].rowEditing)
    },
    toggleAllRowsEdit() {
      this.allRowsEditing = !this.allRowsEditing
      this.form.detail_plan.forEach((_, i) => {
        this.ensureEditStateRow(i)
        this.$set(this.editStates[i], 'rowEditing', this.allRowsEditing)
      })
    },
    // -------------------------------
    addRowDetail() {
      const initPort = [{ value: '', valueOther: '' }]

      console.log(this.form, 'FORM')

      this.form.detail_plan.push({
        number_detail_plan: '',
        fleet_ownership: '',
        fleet_type_id: null,
        fleet_id: null,
        cargo_type_id: null,
        acceptance_date: null,
        terms_id: null,
        terms_remarks: '',
        draught_type: '',
        pol: this.form.ports.length
          ? this.form.ports.map((port) => ({
              value: port.pol,
              valueOther: port.polOther,
            }))
          : initPort,
        pod: this.form.ports.length
          ? this.form.ports.map((port) => ({
              value: port.pod,
              valueOther: port.podOther,
            }))
          : initPort,
        shipment: '',
        eta_pol: null,
        eta_pod: null,
        plan_quantity: null,
        description: '',
        remarks: '',
        selected: false, // Add selected property for checkbox functionality
      })
      // initialize edit state for new row
      const i = this.form.detail_plan.length - 1
      // If in detail (read-only) view, auto-enable edit mode for the new row
      // so user can edit immediately without clicking the edit icon.
      if (!this.editStates) this.editStates = {}
      if (this.isDetail) {
        this.$set(this.editStates, i, { rowEditing: true })
      } else {
        this.$set(this.editStates, i, {})
      }
    },

    deleteRow(idx) {
      this.form.detail_plan.splice(idx, 1)
      // clean up corresponding editState rows by rebuilding keys
      const newStates = {}
      this.form.detail_plan.forEach((_, i) => {
        newStates[i] = this.editStates[i] || {}
      })
      this.editStates = newStates
    },
    deleteAll() {
      this.form.detail_plan = []
    },

    openDescriptionModal(rowData, index) {
      this.currentRowData = rowData
      this.currentRowIndex = index
      this.tempDescription = rowData.description || ''
      this.showDescriptionModal = true
    },

    openRemarksModal(rowData, index) {
      this.currentRowData = rowData
      this.currentRowIndex = index
      this.tempRemarks = rowData.remarks || ''
      this.showRemarksModal = true
    },

    saveDescription() {
      if (this.currentRowData) {
        // Update the form data directly
        this.$set(this.currentRowData, 'description', this.tempDescription)
        // Or you can emit to parent component
        this.$emit('update-description', {
          index: this.currentRowIndex,
          description: this.tempDescription,
        })
      }
      this.closeModals()
    },

    saveRemarks() {
      if (this.currentRowData) {
        // Update the form data directly
        this.$set(this.currentRowData, 'remarks', this.tempRemarks)
        // Or you can emit to parent component
        this.$emit('update-remarks', {
          index: this.currentRowIndex,
          remarks: this.tempRemarks,
        })
      }
      this.closeModals()
    },

    cancelModal() {
      this.closeModals()
    },

    closeModals() {
      this.showDescriptionModal = false
      this.showRemarksModal = false
      this.currentRowData = null
      this.currentRowIndex = null
      this.tempDescription = ''
      this.tempRemarks = ''
    },
    currencyFormat(amount) {
      // Format jumlah tanpa simbol mata uang dan desimal jika bilangan bulat
      const formattedAmount = new Intl.NumberFormat('id-ID', {
        style: 'decimal',
        minimumFractionDigits: amount % 1 === 0 ? 0 : 2, // Menyertakan desimal jika tidak bilangan bulat
      }).format(amount)
      // Mengembalikan hasil tanpa simbol mata uang
      return formattedAmount
    },
    cancelUpdate() {
      // Set all edit states to false (no per-index only)
      if (this.editStates) {
        Object.keys(this.editStates).forEach((k) => {
          if (!this.editStates[k]) this.$set(this.editStates, k, {})
          this.$set(this.editStates[k], 'rowEditing', false)
        })
      }
      this.allRowsEditing = false
      // this.$emit('cancel-update')
    },
  },
}
</script>

<style scoped>
/* Container untuk table dengan fixed header */
.table-container {
  max-height: 600px; /* Atur tinggi maksimal sesuai kebutuhan */
  overflow-y: auto;
  overflow-x: auto;
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
}

/* Table dengan fixed header */
.table-fixed-header {
  margin-bottom: 0;
}

/* Header yang sticky */
.sticky-header {
  position: sticky;
  top: 0;
  z-index: 1000;
  background-color: #f8f9fa !important;
}

.sticky-header th {
  background-color: #f8f9fa !important;
  border-bottom: 2px solid #dee2e6;
  box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4);
}

/* Body yang bisa scroll */
.scrollable-body {
  background-color: white;
}

/* Styling untuk kolom */
table th {
  min-width: 200px;
  position: relative;
  background-color: #f8f9fa !important;
}

.column-1 {
  position: sticky;
  left: 0;
  z-index: 1001 !important;
  min-width: 60px !important;
  background-color: #f8f9fa !important;
}

.column-2 {
  position: sticky;
  left: 60px;
  min-width: 80px !important;
  background-color: #f8f9fa !important;
  z-index: 1001 !important;
}

/* Number Detail Plan column - untuk kondisi !isDetail (ada 2 kolom action) */
.column-number-edit {
  position: sticky;
  left: 140px !important; /* 60px (col-1) + 80px (col-2) */
  min-width: 300px !important;
  background-color: #f8f9fa !important;
  z-index: 1001 !important;
}

/* Number Detail Plan column - untuk kondisi isDetail (hanya 1 kolom action) */
.column-number-detail {
  position: sticky;
  left: 60px !important; /* Hanya 60px (col-1) */
  min-width: 300px !important;
  background-color: #f8f9fa !important;
  z-index: 1001 !important;
}

/* Styling untuk td di kolom sticky - pendekatan universal */
tbody tr td:first-child {
  position: sticky !important;
  left: 0 !important;
  background-color: white !important;
  z-index: 999 !important;
  min-width: 60px !important;
  border-right: 2px solid #dee2e6 !important;
  box-shadow: 2px 0 5px -2px rgba(0, 0, 0, 0.1);
}

/* Kolom kedua hanya jika ada (untuk kondisi !isDetail) */
tbody tr td:nth-child(2):not(:last-child) {
  position: sticky !important;
  left: 60px !important;
  background-color: white !important;
  z-index: 999 !important;
  min-width: 80px !important;
  border-right: 2px solid #dee2e6 !important;
  box-shadow: 2px 0 5px -2px rgba(0, 0, 0, 0.1);
}

/* Number Detail Plan body - untuk kondisi !isDetail */
tbody tr td.column-number-edit {
  position: sticky !important;
  left: 140px !important; /* 60px + 80px */
  background-color: white !important;
  z-index: 999 !important;
  min-width: 300px !important;
  border-right: 2px solid #dee2e6 !important;
  box-shadow: 2px 0 5px -2px rgba(0, 0, 0, 0.1);
}

/* Number Detail Plan body - untuk kondisi isDetail */
tbody tr td.column-number-detail {
  position: sticky !important;
  left: 60px !important; /* Hanya 60px */
  background-color: white !important;
  z-index: 999 !important;
  min-width: 300px !important;
  border-right: 2px solid #dee2e6 !important;
  box-shadow: 2px 0 5px -2px rgba(0, 0, 0, 0.1);
}

/* Border untuk kolom sticky header */
.column-1 {
  border-right: 2px solid #dee2e6 !important;
  box-shadow: 2px 0 5px -2px rgba(0, 0, 0, 0.1);
}

.column-2 {
  border-right: 2px solid #dee2e6 !important;
  box-shadow: 2px 0 5px -2px rgba(0, 0, 0, 0.1);
}

.column-number-edit,
.column-number-detail {
  border-right: 2px solid #dee2e6 !important;
  box-shadow: 2px 0 5px -2px rgba(0, 0, 0, 0.1);
}

/* Pastikan dropdown tidak terpotong */
::v-deep .vs__dropdown-menu {
  z-index: 9999 !important;
}

/* Pastikan dropdown tidak terpotong */
::v-deep .dropdown-menu {
  z-index: 9999 !important;
  position: absolute !important;
}

/* Allow dropdown to overflow table */
tbody tr td {
  overflow: visible !important;
}

::v-deep .searchable-select {
  position: relative;
}
</style>
